import { css } from 'lit';
export const tooltip = css `
  [tooltip] {
    position: relative;
  }

  [tooltip]::after {
    content: attr(tooltip);
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: var(--tooltip-position-top, 100%);
    left: var(--tooltip-position-left, unset);
    right: var(--tooltip-position-right, unset);
    bottom: var(--tooltip-position-bottom, unset);
    margin-top: 5px;
    background-color: var(--surface-color-inverted);
    font-size: 12px;
    pointer-events: none;
    padding: 4px 8px;
    opacity: 0;
    color: var(--type-color-inverted);
    z-index: 1000;
    border-radius: 4px;
    height: var(--tooltip-height, unset);
    font-weight: 400;
    width: var(--tooltip-width, unset);
    max-width: var(--tooltip-max-width, unset);
    min-width: var(--tooltip-min-width, 40px);
    word-break: break-word;
    overflow-wrap: break-word;
    white-space: pre-wrap;
    text-align: var(--tooltip-text-align, unset);
  }

  [tooltip]:hover::after {
    opacity: 0.9;
    transition: opacity 0.3s ease-out;
    transition-delay: 0.4s;
  }
`;
export default tooltip;
